import React, { memo } from 'react';

import styles from './styles/AgentBadges.module.css';

const AgentBadges = ({ isActive = false, accessType = 'PRIVATE', className = '' }) => {
    const containerClass = `${styles.badges} ${className}`.trim();

    return (
        <div className={containerClass}>
            {isActive && <span className={`${styles.badge} ${styles.badgeGreen}`}>Active</span>}
            {accessType && (
                <span className={styles.badge}>{String(accessType).toLowerCase()}</span>
            )}
        </div>
    );
};

export default memo(AgentBadges);
